import { gsap, Sine, Power0, Power1, Power2, Power3, Power4 } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollToPlugin)
gsap.registerPlugin(ScrollTrigger);


// matchMedia
// =======================================================

const mediaQuery_lg = window.matchMedia("(min-width: 1100px)");
const mediaQuery_xl = window.matchMedia("(min-width: 1300px)");
const mediaQuery_md = window.matchMedia("(min-width: 768px)");


// FUNCTION
// =======================================================
function isInPage(node) {
  return (node === document.body) ? false : document.body.contains(node);
}

function closest(node, selector) {
  // IEや一部ブラウザでは.closet()が実装されていないので自前も用意
  return (
    node.closest ||
    function (_selector) {
      do {
        // nodeとselectorがマッチしたら返す
        if ((node.matches || node.msMatchesSelector).call(node, _selector)) {
          return node;
        }
        // マッチしなかったら親要素を代入
        node = node.parentElement || node.parentNode;
      } while (node !== null && node.nodeType === 1);
      return null;
    }
  ).call(node, selector);
}


// ANCHOR
// =======================================================

const anchors = document.querySelectorAll('a[href^="#"]');

anchors.forEach( anchor => {
  anchor.addEventListener("click", function(e) {
    e.preventDefault();
    const href = anchor.getAttribute('href');
    const target = document.getElementById(href.replace('#', ''));

    const positionY = target.getBoundingClientRect().top + window.pageYOffset;
    var offset = 0;

    gsap.to(window, { duration: 0.5, scrollTo: { y: positionY - offset, autoKill: false}, ease: 'power2' });    
  });
});

// Accordion
// =======================================================

const accordions = document.querySelectorAll("[data-ac]");
accordions.forEach( accordion => {
  const trigger = accordion.querySelector('[data-ac-trigger');
  const content = accordion.querySelector('[data-ac-content');
  trigger.addEventListener('click', function(){
    gsap.to(content, {
      height: (accordion.classList.contains("is-open")) ? 0 : "auto",
      duration: 0.25,
      ease: "power2.inOut"
    });
    trigger.classList.toggle("is-open");
    accordion.classList.toggle("is-open");
  })
});

// CLICK EVENT
// =======================================================

// Scroll Up
const topBtn = document.querySelector('.c-btn-top');
topBtn.addEventListener("click", function(e){
  e.preventDefault();
  gsap.to(window, { duration: 0.3, scrollTo: { y: 0, autoKill: false}, ease: 'power2' });
});


// SCROLL TRIGGER
// =======================================================

// Go Top
if(topBtn != null) {
  const fadeInTopBtn = gsap.timeline({
    scrollTrigger: {
      trigger: 'body',
      start: innerHeight/2 + ' top',
      onEnter: () => {
        gsap.to(topBtn, { autoAlpha: 1, duration: 0.4, ease: Sine.easeOut });
      },
      onLeaveBack: () => {
        gsap.to(topBtn, { autoAlpha: 0, duration: 0.4, ease: Sine.easeOut });
      },
    }
  });
}

// SCROLLL

const floadAnimElements = document.querySelectorAll('[data-anim="float"]');

floadAnimElements.forEach( element => {
  var random = Math.floor( Math.random() * 100 ) + 100;
  var randomDuration = (Math.floor( Math.random() * 18 ) + 4 ) / 10;
  gsap.from( element, {
    duration: 1.5,
    y: random,
    scrollTrigger: {
      trigger: element,
      // markers: true,
      scrub: 1, //1秒間アニメーションする
    }
  })  
});

const fadeInAnimElements = document.querySelectorAll('[data-anim="fadeIn"]');

fadeInAnimElements.forEach( element => {
  gsap.from( element, {
    duration: 1.2,
    autoAlpha: 0,
    scrollTrigger: {
      trigger: element,
      start: "top 80%",
      end: "bottom bottom",
    }
  })  
});

const planAnimElements = document.querySelectorAll('[data-anim="plane"]');
planAnimElements.forEach( element => {
  gsap.from( element, {
    duration: 1.4,
    x: 220,
    scrollTrigger: {
      trigger: element,
      scrub: 1,
    }
  })
});

const bgColorAnimElement = document.querySelector('[data-anim="bgcolor"]');
gsap.to( bgColorAnimElement, {
  duration: 1.4,
  "background-position": "0 100%",
  scrollTrigger: {
    trigger: bgColorAnimElement,
    start: "top center",
    end: "bottom bottom",
    scrub: 0.5,
  }
})


// const bgAnimElements = document.querySelectorAll('[data-anim="bg"]');
// bgAnimElements.forEach( element => {
//   gsap.from( element, {
//     duration: 1.4,
//     y: 70,
//     scrollTrigger: {
//       trigger: element,
//       start: "top center",
//       end: "bottom bottom",
//       markers: true,
//       scrub: 1, //1秒間アニメーションする
//     }
//   })
// });

let mm = gsap.matchMedia();
mm.add("(min-width: 1000px)", () => {
  const floadIllustElements = document.querySelectorAll('[data-anim="floatIllust"]');

  floadIllustElements.forEach( element => {
    gsap.from( element, {
      duration: 1.5,
      y: 50,
      scrollTrigger: {
        trigger: element,
        scrub: 1,
      }
    })  
  });
});
